import script from "./SideMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./SideMenu.vue?vue&type=script&setup=true&lang=js"

import "./SideMenu.vue?vue&type=style&index=0&id=4f79428a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_91df7c0921f9e575f6107cb232f4ee79/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f79428a"]])

export default __exports__